import { render, staticRenderFns } from "./WastewaterIcon.vue?vue&type=template&id=4755a432"
import script from "./WastewaterIcon.vue?vue&type=script&lang=js"
export * from "./WastewaterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports